import React from "react";
import { Header } from "semantic-ui-react";

const RegisterFormHeader = () => {
  return (
    <>
      <Header as="h1" color="blue" textAlign="center" size="huge">
        Crea tu usuario y contraseña
      </Header>
      <Header as="h5" color="blue" textAlign="center">
        Registrate en 3 simples pasos
      </Header>
    </>
  );
};

export default RegisterFormHeader;
